import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";
import AboutUs from "../../Components/AboutUs/index";
import Body7 from "../../Components/Home-new/Body7";
import Body9 from "../../Components/Home-new/Body9";
import { AboutDataProvider, useAboutData } from "../../database/AboutDataContext";
import { AboutUsSkeleton, Body7Skeleton, Body9Skeleton } from "../../Components/Skeletons/Skeletons";

const AboutPageContent = () => {
    const { data, isLoading } = useAboutData();

    if (isLoading) {
        return (
            <>
                <AboutUsSkeleton />
                <Body7Skeleton />
                <Body9Skeleton />
            </>
        );
    }

    return (
        <>
            <div >
                <AboutUs preloadedData={data.aboutUs} />
            </div>
            <Body7 preloadedData={data.body7} />
            <Body9 preloadedData={data.body9} />
        </>
    );
};

const About = () => {
    return (
        <AboutDataProvider>
            <SEO pageName="about" />
            <Navbar />
            <AboutPageContent />
            <Footer />
        </AboutDataProvider>
    );
};

export default About;
